import {RuleTabEnum} from "../enum/RuleTab.enum";
import {ModalContent, Operators} from "../RuleService.const";
import {enumSnackbarStatusType} from "../../../types/enums";
import i18n from 'i18next';

export function getModalContent(type: RuleTabEnum) {
    return Object.assign({}, ModalContent[type]);
}

export function getSnackbarActionMessage(tab: any, type: any, action: any) {
    const successPrefix = type == enumSnackbarStatusType.success ? "Success" : "Failed";

    switch (tab) {
        case RuleTabEnum.Rule:
            switch (action) {
                case "get":
                    return i18n.t(`ruleManagement.notify.rule.getRuleList${successPrefix}`);
                case "create":
                    return i18n.t(`ruleManagement.notify.rule.create${successPrefix}NewRule`);
                case "update":
                    return i18n.t(`ruleManagement.notify.rule.update${successPrefix}NewRule`);
                case "delete":
                    return i18n.t(`ruleManagement.notify.rule.delete${successPrefix}NewRule`);
            }
            break;
        case RuleTabEnum.RuleTemplate:
            switch (action) {
                case "get":
                    return i18n.t(`ruleManagement.notify.ruleTemplate.getRuleTemplateList${successPrefix}`);
                case "create":
                    return i18n.t(`ruleManagement.notify.ruleTemplate.create${successPrefix}NewRuleTemplate`);
            }
            break;
        case RuleTabEnum.CriteriaType:
            switch (action) {
                case "get":
                    return i18n.t(`ruleManagement.notify.criteriaType.getCriteriaTypeList${successPrefix}`);
                case "create":
                    return i18n.t(`ruleManagement.notify.criteriaType.create${successPrefix}NewCriteriaType`);
            }
            break;
    }
    return "";
}

export function getSnackbarValue(response: any) {
    let snackBarSettings = {
        show: true,
        message: "",
        status: enumSnackbarStatusType.success,
    };
    if (!response) return snackBarSettings;
    if (response.result.includes("Exception")) {
        snackBarSettings.message = response.result;
        snackBarSettings.status = enumSnackbarStatusType.danger;
    } else if (response.result.includes("validation")) {
        const result = JSON.parse(response.result);
        const validationErrors = Object.values(result.errors);
        snackBarSettings.message = validationErrors.join("<br>");
        snackBarSettings.status = enumSnackbarStatusType.danger;
    } else {
        snackBarSettings.message = "Kayıt başarılı";
    }
    return snackBarSettings;
}

export function validateRuleTemplate(data: any) {
    let isValid = true;
    let messages = [] as any[]

    if (!data.Name) {
        messages.push(i18n.t(`ruleManagement.fields.ruleTemplate.name.validationMessage`))
        isValid = false
    }
    if (data.criteriaTypes.length > 0 && data.criteriaTypes?.some((k: any) => k.CriteriaTypeId === "" || k.Operator === "")) {
        messages.push(i18n.t(`ruleManagement.fields.ruleTemplate.criteriaType.validationMessage`))
        messages.push(i18n.t(`ruleManagement.fields.ruleTemplate.operator.validationMessage`))
        isValid = false
    }
    return {
        isValid, messages
    }
}

export function validateCriteriaTypes(data: any) {
    let isValid = true;
    let messages = [] as any[]
    if (!data.Key) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.key.validationMessage`))
        isValid = false;
    }
    if (!data.Name) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.name.validationMessage`))
        isValid = false
    }
    if (data.hasPredefinedValue && data.criteriaTypeValues.length > 0 && data.criteriaTypeValues.some((k: any) => k.Name === "" || k.Value === "")) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.hasPredefinedValue.validationMessage`))
        isValid = false
    }
    return {
        isValid, messages
    }
}

export function validateRule(data: any) {
    let isValid = true;
    let messages = [] as any[]
    if (!data.ruleTemplateId) {
        messages.push(i18n.t(`ruleManagement.fields.rule.ruleTemplate.validationMessage`))
        isValid = false;
    }
    if (!data.ruleKey) {
        messages.push(i18n.t(`ruleManagement.fields.rule.ruleKey.validationMessage`))
        isValid = false
    }
    if (!data.action) {
        messages.push(i18n.t(`ruleManagement.fields.rule.action.validationMessage`))
        isValid = false
    }
    if (!data.priority) {
        messages.push(i18n.t(`ruleManagement.fields.rule.priority.validationMessage`))
        isValid = false
    }
    if (!data.effectiveDate) {
        messages.push(i18n.t(`ruleManagement.fields.rule.effectiveDate.validationMessage`))
        isValid = false
    }
    if (!data.endDate) {
        messages.push(i18n.t(`ruleManagement.fields.rule.endDate.validationMessage`))
        isValid = false
    }
    if (data.criteria && data.criteria.length > 0 && data.criteria.some((k: any) => k.key === "" || k.value === "")) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.hasPredefinedValue.validationMessage`))
        isValid = false
    }
        data.criteria.forEach((item: any) => {
            if (item.operator == Operators()[1].value ||

                item.operator == Operators()[3].value ||
                item.operator == Operators()[4].value) {

                let values = item.value.split("#")
                let valueA = parseInt(values[0])
                let valueB = parseInt(values[1])
                if (!valueA) {
                    messages.push(i18n.t(`ruleManagement.fields.rule.logical.null`))
                    isValid = false
                }
                if (valueA && valueA >= valueB) {
                    messages.push(i18n.t(`ruleManagement.fields.rule.logical.openInterval`))
                    isValid = false
                }
            }
            if (item.operator == Operators()[2].value) {
                let values = item.value.split("#")
                let valueA = parseInt(values[0])
                let valueB = parseInt(values[1])
                if (!valueA) {
                    messages.push(i18n.t(`ruleManagement.fields.rule.logical.null`))
                    isValid = false
                }
                if (valueA && valueA > valueB) {
                    messages.push(i18n.t(`ruleManagement.fields.rule.logical.closedInterval`))
                    isValid = false
                }
            }
        })

    return {
        isValid, messages
    }
}



